import {
  ScrollSidebarTitleItem,
  SidebarDivider,
} from '@equifinance/shared';
import { useTabNavHeight } from '../AccountTabNav';
import ProductSidebarHeader from '../Products/ProductSidebar/ProductSidebarHeader';
import ProductSidebarSummary from '../Products/ProductSidebar/ProductSidebarSummary';

export const AuditHistoryRefName = 'audit-history';

export default function AuditSidebar() {
  const stickyHeaderOffset = useTabNavHeight();

  return (
    <>
      <ProductSidebarHeader />

      <SidebarDivider />

      <ScrollSidebarTitleItem
        stickyHeaderOffset={stickyHeaderOffset}
        refName={AuditHistoryRefName}
      >
        Audit History
      </ScrollSidebarTitleItem>

      <ProductSidebarSummary />
    </>
  );
}
